import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckBtnIcon = ({ title, titleId,...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "18px",
	height: "18px",
	viewBox: "0 0 18 18",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsx("g", {
			transform: "translate(-672.000000, -530.000000)",
			children: /* @__PURE__ */ _jsx("g", {
				transform: "translate(659.000000, 521.000000)",
				children: /* @__PURE__ */ _jsxs("g", {
					transform: "translate(12.000000, 8.000000)",
					children: [
						/* @__PURE__ */ _jsx("mask", {
							id: "mask-78jgfglk",
							fill: "white",
							children: /* @__PURE__ */ _jsx("path", { d: "M10,1.66666667 C5.4,1.66666667 1.66666667,5.4 1.66666667,10 C1.66666667,14.6 5.4,18.3333333 10,18.3333333 C14.6,18.3333333 18.3333333,14.6 18.3333333,10 C18.3333333,5.4 14.6,1.66666667 10,1.66666667 Z M10,3.33333333 C13.675,3.33333333 16.6666667,6.325 16.6666667,10 C16.6666667,13.675 13.675,16.6666667 10,16.6666667 C6.325,16.6666667 3.33333333,13.675 3.33333333,10 C3.33333333,6.325 6.325,3.33333333 10,3.33333333 Z M13.825,6.31666667 L8.33333333,11.8083333 L6.175,9.65833333 L5,10.8333333 L8.33333333,14.1666667 L15,7.5 L13.825,6.31666667 Z" })
						}),
						/* @__PURE__ */ _jsx("g", { fillRule: "nonzero" }),
						/* @__PURE__ */ _jsx("g", {
							mask: "url(#mask-78jgfglk)",
							fill: "#FFFFFF",
							children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("rect", {
								x: 0,
								y: 0,
								width: 20,
								height: 20
							}) })
						})
					]
				})
			})
		})
	})]
});
const ForwardRef = forwardRef(SvgCheckBtnIcon);
export { ForwardRef as ReactComponent };
